import { FC } from "react";
import { Modal } from '@sainsburys-tech/luna-modal'
import { AddPopupType } from "../../../Interfaces/IAddFieldModalProps";
import "./familyGroupModalEdit.scss";
import FamilyGroupEditFormEdit from "./familyGroupFields";

const FamilyGroupModalEdit: FC<AddPopupType> = ({
  isOpen,
  handleClose,
  handleAddCallback: handleAdd,
  title,
}) => {
  const closeHandler = () => {
    handleClose(false);
  };
  return (
    <div className="familyGroupModal" data-testid="family-group-modal-wrapper">
      <Modal
        classNanme="familyGroupModal"
        small
        handleClose={() => closeHandler()}
        open={isOpen}
        headingId="info-modal"
        stickyHeader="Sticky Header"
        restrictClose={true}
      >
        <FamilyGroupEditFormEdit closeModal={closeHandler} />
      </Modal>
    </div>
  );
};

export default FamilyGroupModalEdit;
